// extracted by mini-css-extract-plugin
var _1 = "VersionNameForm-module__animateUploadProgressBarWidth--ENRcG";
var _2 = "VersionNameForm-module__animatedBackground--xIrcy";
var _3 = "VersionNameForm-module__versionNameInput--BFFuh";
var _4 = "VersionNameForm-module__versionNameInputContainer--D3Ioi";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "versionNameInput", _4 as "versionNameInputContainer" }
